module.exports = __webpack_public_path__ + "images/frontpage_hint@1x.png?bf60b0de";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_hint@1x.png
// module id = 642
// module chunks = 7